import React from 'react'
import { Tab, Tabs } from '@mui/material'

interface FacebookTabsProps {
  tab: FacebookTabsEnum
  onChangTab: (tab: FacebookTabsEnum) => void
  disabled: {
    replyChat: boolean
    digChat: boolean
  }
}

export enum FacebookTabsEnum {
  ReplyChat = 'replyChat',
  DigChat = 'digChat',
  Setting = 'settingChat',
}

const FacebookTabs = (props: FacebookTabsProps) => {
  const { tab, onChangTab,disabled } = props

  return (
    <Tabs value={tab} onChange={(event: React.SyntheticEvent, newTab: FacebookTabsEnum) => onChangTab(newTab)}>
      <Tab label="ตอบแชท" value={FacebookTabsEnum.ReplyChat} disabled={disabled.replyChat} />
      <Tab label="ขุดแชท" value={FacebookTabsEnum.DigChat} disabled={disabled.digChat} />
      <Tab label="ตั้งค่า" value={FacebookTabsEnum.Setting}/>
    </Tabs>
  )
}

export default FacebookTabs
